import React from 'react';
import styles from './Component/CSS/SeriesPlayScreen.module.css';
import Loading from '../common/HousGlass Loader/Loading';
import { useAudioPlayer } from '../components/audio/AudioPlayerContext';
import { useSubscriptionCheck } from '../hooks/useSubscriptionCheck';

const SeriesPlayScreen = ({ audioData, chapters }) => {
  
  // Use the global audio player context
  const { currentAudio, playAudio, isPlaying } = useAudioPlayer();
  const { checkSubscriptionBeforePlay } = useSubscriptionCheck();
  
  // Handle case when data is not yet loaded
  if (!audioData || !chapters || chapters.length === 0) {
    return <div className={styles.loading}><Loading/></div>;
  }
  
  const firstAudioChapter = chapters.find(chapter => chapter.type === "audio");

  const handleListenClick = (slug) => {
    // Check subscription before playing
    if (!checkSubscriptionBeforePlay()) {
      return;
    }

    if (firstAudioChapter) {
      // Format chapter data for the audio player
      const audioPlayerData = {
        id: firstAudioChapter.id,
        title: firstAudioChapter.audio_title || audioData.title,
        author: audioData.creator?.name || "Unknown Author",
        song_url: firstAudioChapter.audio_url,
        image: firstAudioChapter.audio_computer_image || firstAudioChapter.audio_mobile_image || audioData.coverImageUrl,
        duration: firstAudioChapter.audio_duration,
        audioId:firstAudioChapter.audio_id,
        slug: slug // Add the slug to the audio player data
      };
      
      // Play the audio using the global context
      playAudio(audioPlayerData);
    }
  };
  
  // Check if the first episode is currently playing
  const isFirstEpisodePlaying = () => {
    return currentAudio && currentAudio.id === firstAudioChapter?.id;
  };
  
  // Format duration from seconds to minutes:seconds
  const formatDuration = (seconds) => {
    if (!seconds) return '0:00';
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.imageSection}>
          <img
            src={audioData.coverImageUrl}
            alt="Series Cover"
            className={styles.coverImage}
          />
        </div>
        
        <div className={styles.contentSection}>
          <h1 className={styles.title}>{audioData.title}</h1>
          
          <div className={styles.metadataSection}>
            <div className={styles.metadataItem}>
              <span className={styles.metadataLabel}>Creator:</span>
              <span className={styles.metadataValue}>{audioData.creator?.name}</span>
            </div>
            <div className={styles.metadataItem}>
              <span className={styles.metadataLabel}>Genre:</span>
              <span className={styles.metadataValue}>{audioData.category?.name}</span>
            </div>
            <div className={styles.metadataItem}>
              <span className={styles.metadataLabel}>Language:</span>
              <span className={styles.metadataValue}>{audioData.language}</span>
            </div>
            <div className={styles.metadataItem}>
              <span className={styles.metadataLabel}>Episodes:</span>
              <span className={styles.metadataValue}>{chapters.length}</span>
            </div>
          </div>
          
          <p className={styles.description}>{audioData.description}</p>
          
          <div className={styles.buttonContainer}>
            <button 
              className={styles.redButton}
              onClick={() => handleListenClick(audioData.slug || firstAudioChapter.slug)}
              disabled={!firstAudioChapter || !firstAudioChapter.audio_url}
            >
              <span className={styles.playIcon}>▶</span> Listen Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeriesPlayScreen;